module.exports = __webpack_public_path__ + "media/images/iconClose--dark-7a7a8de577e774e32f6d8be2221854f5.png";